import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QRButton } from '@base/src/app/models/qr-button.model';
import { TableHeader } from '@base/src/app/models/tableheader.model';
import { UtilsService } from '@base/src/app/services/utils.service';
import { ReservationsBody } from '@base/src/app/store/states/filters-reservations.state';
import * as moment from 'moment';
import { MomentInput } from 'moment';
import { OrderByTableHeader } from '../../../../../../components/ui/table-header-new/table-header-new.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { QRInputAutocomplete } from '@base/src/app/models/qr-input-autocomplete.model';
import { QRInput } from '@base/src/app/models/qr-input.model';
import {
  RequestAll,
} from '@base/src/app/pages/stats/reservometro/reservometro-panel/reservometro-panel.component';
import { AgentData, Reservation } from '@base/src/app/pages/stats/reservometro/models/reservation.model';
import { ReservometroStatisticsService } from '../../../services/reservometro-statistics.service';


@Component({
  selector: 'app-dialog-solicitud-actualizacion',
  templateUrl: './dialog-solicitud-actualizacion.component.html',
  styleUrls: ['./dialog-solicitud-actualizacion.component.scss'],
})
export class DialogSolicitudActualizacionComponent implements OnInit {
  @Input() listAgents!: AgentData[];
  @Input() agencyId: number | undefined;
  @Input() userId!: string | undefined;
  @Output() change: EventEmitter<{
    id: string;
    value: { statisticsId: string[]; selected: Reservation[] };
  }> = new EventEmitter();
  @Output() changeAll: EventEmitter<RequestAll> =
    new EventEmitter<RequestAll>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  isLoading = false;

  inputAutocompleteAgent: QRInputAutocomplete = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Seleccione un agente...',
    isCleanButtonVisible: true,
    options: [],
  };

  isTableHeaderVisible: boolean = false;

  private readonly HEADER_ID_CHECKBOX: string = 'checkbox';
  private readonly HEADER_ID_ADDRESS: string = 'address';
  private readonly HEADER_ID_EXPIRED: string = 'expirationDate';
  private readonly HEADER_ID_ESTIMATED_CLOSE_DATE: string = 'estimateCloseDate';
  private readonly HEADER_ID_NUM_REQ_UPD: string = 'numReqUpd';
  private readonly HEADER_ID_LAST_REQ_UPDATE: string = 'lastReqUpdDate';

  tableHeader: TableHeader[] = [
    {
      id: this.HEADER_ID_CHECKBOX,
      text: '',
      percentageWidth: 10,
      isOrderByVisible: false,
    },
    {
      id: this.HEADER_ID_ADDRESS,
      text: 'Reserva',
      percentageWidth: 25,
      isOrderByVisible: true,
    },
    {
      id: this.HEADER_ID_EXPIRED,
      text: 'Vencimiento',
      percentageWidth: 15,
      isOrderByVisible: true,
    },
    {
      id: this.HEADER_ID_ESTIMATED_CLOSE_DATE,
      text: 'Cierre estimado',
      percentageWidth: 20,
      isOrderByVisible: true,
    },
    {
      id: this.HEADER_ID_NUM_REQ_UPD,
      text: 'Veces enviado',
      percentageWidth: 15,
      isOrderByVisible: true,
    },
    {
      id: this.HEADER_ID_LAST_REQ_UPDATE,
      text: 'Último envio',
      percentageWidth: 15,
      isOrderByVisible: true,
    },
  ];

  filters: ReservationsBody = {
    idAgency: 0,
    userId: '',
    startEstimatedCloseDate: '',
    endEstimatedCloseDate: '',
    startExpirationDate: '',
    endExpirationDate: '',
    address: '',
    statisticsTypeId: 2,
    statisticsState: [],
    organizationIdVendedor: '',
    operationType: '',
    mlsid: '',
    credit: '',
  };

  reservationsList: Reservation[] = [];

  buttonCancel: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Cancelar',
  };

  buttonActualizar: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Actualizar',
  };

  checked: boolean = false;
  order: string = 'ASC';
  agentId: number | undefined;
  selectedReservations: Reservation[] = [];
  agentsListId: string[] = [];
  agentsListSelected: string[] = [];
  reservationsListId: string[] = [];
  isSelectedAll: boolean = false;

  constructor(
    private readonly reservometroSearch: ReservometroStatisticsService,
    public utilsService: UtilsService
  ) {}

  ngOnInit(): void {
    this.filters.idAgency = this.agencyId ?? 0;
    this.filters.userId = this.userId ?? '';
    this.inputAutocompleteAgent.options.push('Todos');

    this.listAgents.sort((a, b) =>
      a.agentName.localeCompare(b.agentName, 'es', { sensitivity: 'base' })
    );

    this.listAgents.forEach((agent) => {
      this.agentsListId.push(String(agent.agent));
      this.inputAutocompleteAgent.options.push(agent.agentName);
    });
  }

  inputAutocompleteChange(selected: string | string[] | undefined): void {
    this.isTableHeaderVisible = true;
    this.isSelectedAll = selected === 'Todos';
    this.selectedReservations = [];
    this.reservationsListId = [];

    const SELECTED =
      this.listAgents.find((agent) => agent.agentName === selected) ??
      selected === 'Todos';

    let agentId: number | undefined = undefined;

    if (typeof SELECTED === 'object' && SELECTED !== null) {
      // Es objeto agente
      agentId = SELECTED.agent;
    } else {
      // Es booleano (true) en caso de ser 'TOD0S', asignamos undefined a agentId
      agentId = undefined;
    }

    this.agentId = agentId;

    this.filters.organizationIdVendedor =
      selected === 'Todos' || agentId === undefined ? '' : String(agentId);

    this.filters.statisticsState = ['4', '5'];
    this.isLoading = true;
    const URL_ADVANCED_SEARCH: string = `${this.filters.idAgency}/reservation/current-next/`;
    
    this.reservometroSearch
      .post(this.filters, URL_ADVANCED_SEARCH)
      .then((response) => {
        const BODY = response.body;
        this.reservationsList = BODY.reservaList;
        this.isLoading = false;
      });
  }

  checkboxChange(reservation: Reservation): void {
    const INDEX = this.selectedReservations.findIndex(
      (item) => item.id === reservation.id
    );

    if (INDEX === -1) {
      this.selectedReservations.push(reservation);
      this.reservationsListId.push(String(reservation.id));
    } else {
      this.selectedReservations.splice(INDEX, 1);
      this.reservationsListId.splice(INDEX, 1);
    }

    if (this.isSelectedAll) this.updateSelectedAgents();
  }

  updateSelectedAgents(): void {
    const AGENT_IDS_SET = new Set<string>();

    this.selectedReservations.forEach((res) => {
      const NAME_SELLER = res.organizationNameVendedor?.trim().toLowerCase();
      const NAME_BUYER = res.organizationNameComprador?.trim().toLowerCase();

      const MATCHED_SELLER = this.listAgents.find(
        (agent) => agent.agentName?.trim().toLowerCase() === NAME_SELLER
      );
      const MATCHED_BUYER = this.listAgents.find(
        (agent) => agent.agentName?.trim().toLowerCase() === NAME_BUYER
      );

      if (MATCHED_SELLER) AGENT_IDS_SET.add(String(MATCHED_SELLER.agent));
      if (MATCHED_BUYER) AGENT_IDS_SET.add(String(MATCHED_BUYER.agent));
    });

    this.agentsListSelected = Array.from(AGENT_IDS_SET);
  }

  setWidthColumn(idColumn: string): number | undefined {
    let width = 0;

    this.tableHeader.forEach((e) => {
      if (e.id == idColumn) width = e.percentageWidth!;
    });
    return width;
  }

  //ORDENAR LISTADO
  tableOrderByChange(orderBy: OrderByTableHeader): void {
    //compara alfabeticamente
    const compareFunctionAlph = (
      a: Reservation,
      b: Reservation,
      property: keyof Reservation
    ) => {
      return orderBy.orientation === 'ASC'
        ? (a[property] as string).localeCompare(b[property] as string)
        : (b[property] as string).localeCompare(a[property] as string);
    };

    //compara fechas
    const compareFunctionDate = (
      a: Reservation,
      b: Reservation,
      property: keyof Reservation
    ) => {
      const DATE_A = moment(a[property] as MomentInput, 'YYYY/MM/DD');
      const DATE_B = moment(b[property] as MomentInput, 'YYYY/MM/DD');

      // Primero ordenar por fecha
      const DATE_COMPARISON =
        orderBy.orientation === 'ASC'
          ? DATE_A.diff(DATE_B)
          : DATE_B.diff(DATE_A);

      // Si las fechas son iguales, subordenar por el id
      if (DATE_COMPARISON === 0) {
        return orderBy.orientation === 'ASC'
          ? a['id'] - b['id']
          : b['id'] - a['id'];
      }

      return DATE_COMPARISON;
    };

    switch (orderBy.column) {
      case this.HEADER_ID_ADDRESS:
        this.reservationsList = [...this.reservationsList].sort((a, b) =>
          compareFunctionAlph(a, b, 'address')
        );
        break;
      case this.HEADER_ID_EXPIRED:
        this.reservationsList = [...this.reservationsList].sort((a, b) =>
          compareFunctionDate(a, b, 'expirationDate')
        );
        break;
      case this.HEADER_ID_ESTIMATED_CLOSE_DATE:
        this.reservationsList = [...this.reservationsList].sort((a, b) =>
          compareFunctionDate(a, b, 'estimateCloseDate')
        );
        break;
    }
  }

  tableCheckboxChange(matCheckbox: MatCheckboxChange): void {
    this.checked = matCheckbox.checked;
    if (this.checked) {
      this.agentsListSelected = this.agentsListId;
      this.selectedReservations = [];
      this.selectedReservations = this.reservationsList;
      this.reservationsListId = [];
      this.selectedReservations.forEach((element) => {
        this.reservationsListId.push(String(element.id));
      });
      this.updateSelectedAgents();
    } else {
      this.selectedReservations = [];
      this.reservationsListId = [];
      this.agentsListSelected = [];
    }
  }

  confirmProcess(): void {
    if (
      this.reservationsList.length === 0 ||
      this.selectedReservations.length === 0
    ) {
      return;
    }

    if (this.agentsListSelected.length > 1) {
      const BODY: RequestAll = {
        statisticsId: this.reservationsListId,
        agentsId: this.agentsListSelected,
        userId: this.userId,
        sendCopy: true,
      };
      this.changeAll.emit(BODY);
    } else {
      const AGENT_ID = this.agentId ?? this.agentsListSelected[0];
      if (AGENT_ID == null) {
        return;
      }

      const BODY = {
        statisticsId: this.reservationsListId,
        selected: this.selectedReservations,
      };
      this.change.emit({ id: String(AGENT_ID), value: BODY });
    }
  }

  closeDialog(): void {
    this.close.emit(true);
  }
}
